import service from '../apihttp'
import config from '@/assets/config.json'
//创建优惠券
//获取商铺
export function shopList(data) {
    const url = config.newHttps.api + '/merchant/coupons/shop/list'
    return service.get(url, data, {
        'Authorization': `Bearer ${localStorage.getItem("Beitoken")}`
    })
}
//获取商品
export function couponsList(data) {
    const url = config.newHttps.api + '/merchant/goods/couponslist'
    return service.get(url, data, {
        'Authorization': `Bearer ${localStorage.getItem("Beitoken")}`
    })
}
//获取商品详情
export function couponsgoodsList(data) {
    const url = config.toponhttp.api + '/merchant/coupons/goods/list'
    return service.post(url, data, )
}
//优惠券创建
export function couponCreate(data) {
    const url = config.chaohui.api + '/coupon/create'
    return service.post(url, data, {
        'Authorization': `Bearer ${localStorage.getItem("Beitoken")}`
    })
}
//优惠券批次密钥
export function couponGenerateCode(data) {
    const url = config.chaohui.api + '/coupon/generateCode'
    return service.get(url, data, )
}
//优惠券列表
export function couponAll(data) {
    const url = config.chaohui.api + '/coupon/all'
    return service.post(url, data, {
        'Authorization': `Bearer ${localStorage.getItem("Beitoken")}`
    })
}
//启用
export function couponEnable(data) {
    const url = config.chaohui.api + '/coupon/enable'
    return service.post(url, data, {
        'Authorization': `Bearer ${localStorage.getItem("Beitoken")}`
    })
}
//停用
export function couponDisable(data) {
    const url = config.chaohui.api + '/coupon/disable'
    return service.post(url, data, {
        'Authorization': `Bearer ${localStorage.getItem("Beitoken")}`
    })
}
//查询优惠券数量
export function couponFindCouponCount(data) {
    const url = config.chaohui.api + '/coupon/findCouponCount?couponId=' + data
    return service.post(url)
}
//优惠券店铺/商品列表
export function merchantCouponsInfoList(data) {
    const url = config.newHttps.api + '/merchant/coupons/info/list'
    return service.post(url, data)
}
//查询优惠券操作
export function couponStatusLogFindAbleInfo(data) {
    const url = config.chaohui.api + '/couponStatusLog/findAbleInfo?couponId=' + data
    return service.post(url)
}
// 查看详情优惠券列表
export function couponChildAll(data) {
    const url = config.chaohui.api + '/couponChild/all'
    return service.post(url, data)
}
// 审核状态时间线
export function couponCheckInfo(couponId) {
    const url = config.chaohui.api + `/coupon/checkInfo/${couponId}`
    return service.get(url, {
        'Authorization': `Bearer ${localStorage.getItem("Beitoken")}`
    })
}
// 导出
export function dcExportCouponChild(data) {
    const url = config.chaohui.api + `/couponChild/exportCouponChild`
    return service.blob(url, data)
}